import config from '../../../configuration/configuration.js';
import AxiosRequest from '../../../utils/AxiosRequest';

export const RETFilesUploadRequest = (filePath, userName, userId) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}RanReportKpis/RETFilesUpload`,
	params: { filePath, userName, userId }
});
